import axios from "../services/api/api";
import { AUTH_BASE_URL, API_BASE_URL } from "../constants/api.constants";
import { FormattedMessage } from "react-intl";

/** HELPER FUNCTIONS **/
const toFormData = (file, paramName, fileName) => {
  if (!file) return null;

  var myData = new FormData();
  if (fileName !== null || fileName !== undefined) {
    myData.append(paramName, file, fileName);
  } else {
    myData.append(paramName, file);
  }
  return myData;
};

const errorMessage = (err) => {
  if (err && err.response?.data?.length > 0) {
    return err.response.data;
  } else if (err && err.response && err.response.statusText) {
    return err.response.statusText;
  } else if (err && err.request) {
    return err.request.data;
  } else {
    return <FormattedMessage id="GenericApiError" />;
  }
};
/** END HELPER FUNCTIONS **/

export const HandleAddNewStudent = async (values) => {
  const data = await axios
    .post("/student", {
      email: values.values.email,
      name: values.values.name,
      classId: values.values.classId,
    })
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const HandleMoveStudentsToClass = async (values) => {
  const data = await axios
    .post(
      `${API_BASE_URL}/Student/AddstudentsToClass?studentIds=${values.selectedStudentIds.join(
        "&studentIds="
      )}&classId=${values.classId}`
    )
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const HandleUserNameChange = async (values) => {
  const data = await axios
    .put("/user/UpdateUser", {
      name: values.newName,
      oldEmail: values.oldEmail,
      newEmail: values.newEmail,
    })
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const UploadDocument = async (values) => {
  const response = await axios
    .post(
      `${API_BASE_URL}/Teacher/UploadFileToCourse?courseId=${values.values.courseId}&teacherId=${values.values.teacherId}&classId=${values.values.classId}${values.values.moduleids}`,
      toFormData(values.values.file, "file", values.values.fileName),
      { headers: { "Content-Type": "multipart/form-data;" } }
    )
    .catch((err) => {
      return errorMessage(err);
    });
  return response;
};

export const DeleteUpload = async (values) => {
  const response = await axios
    .post(
      `${API_BASE_URL}/Teacher/UploadDelete?item=${values.item}&classId=${values.classId}&courseId=${values.courseId}&teacherId=${values.teacherId}`
    )
    .catch((err) => {
      return errorMessage(err);
    });
  return response;
};

export const UploadLink = async (values) => {
  const response = await axios
    .post(
      `${API_BASE_URL}/Teacher/UploadLinkToCourse?link=${values.values.link}&courseId=${values.values.courseId}&teacherId=${values.values.teacherId}&classId=${values.values.classId}${values.values.moduleids}`
    )
    .catch((err) => {
      return errorMessage(err);
    });
  return response;
};

export const CheckIfEmailIsOccupied = async (values) => {
  const response = await axios
    .post(
      `${AUTH_BASE_URL}/token/IsEmailTaken/?email=${encodeURIComponent(
        values.newEmail
      )}`
    )
    .catch((err) => {
      return errorMessage(err);
    });
  return response;
};

export const HandleUserEmailChange = async (values) => {
  if (values.oldEmail !== values.newEmail) {
    const data = await axios.post(`${AUTH_BASE_URL}/token/UpdateUserEmail`, {
      oldEmail: values.oldEmail,
      newEmail: values.newEmail,
    });
    axios
      .put("/user/UpdateUser", {
        name: values.userName,
        oldEmail: values.oldEmail,
        newEmail: values.newEmail,
      })
      .catch((err) => {
        return errorMessage(err);
      });
    return data;
  }
};

export const HandleFinalExamLockingAndUnlocking = async (values) => {
  const data = await axios
    .post(`${API_BASE_URL}/teacher/activatefinalexam`, values.values)
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const HandleStudentClassChange = async (values) => {
  const response = await axios
    .post("/Student/ChangeClass", {
      Id: values.id,
      Name: values.name,
      class: {
        name: values.class.name,
        id: values.class.id,
        schoolId: values.class.schoolId,
      },
    })
    .catch((err) => {
      return errorMessage(err);
    });
  return response;
};

export const HandleDeleteStudent = async (values) => {
  const response = await axios
    .post(
      `${API_BASE_URL}/User/SetDeleted?email=${encodeURIComponent(
        values.studentEmail
      )}&isDeleted=${true}`
    )
    .catch((err) => {
      return errorMessage(err);
    });
  return response;
};

export const HandleClassEdit = async (values) => {
  const data = await axios
    .post(`${API_BASE_URL}/Class/UpdateClass`, {
      id: values.id,
      name: values.name,
      school: values.school,
      programme: values.programme,
      orientation: values.orientation,
      teachers: values.teachers,
    })
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const HandleAddNewTeacher = async (values) => {
  const data = await axios
    .post(`${API_BASE_URL}/Teacher`, {
      name: values.name,
      email: values.email,
      FullAccess: values.fullAccess,
      Purchaser: values.purchaser,
    })
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const HandleProgramEdit = async (program) => {
  const data = await axios
    .put(`${API_BASE_URL}/programme`, program.program)
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const AddNewClass = async (cl) => {
  const data = await axios
    .post("/class", {
      name: cl.cl.name,
      school: cl.cl.school,
      programme: cl.cl.program,
      orientation: cl.cl.orientation,
    })
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const AddTeachersToClass = async (values) => {
  const data = await axios
    .post(
      `/AddTeachersToClass?teacherIds=${values.teacherIds.join(
        "&teacherIds="
      )}&classId=${values.classId}`
    )
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const DeleteClass = async (classId) => {
  const data = await axios.delete(`/Class/${classId.id}`).catch((err) => {
    return errorMessage(err);
  });
  return data;
};

// APL MUTATIONS

export const PostAplPeriod = async (period) => {
  const data = await axios.post(`/Apl/PostPeriod`, period).catch((err) => {
    return errorMessage(err);
  });
  return data;
};

export const PostSupervisorCompany = async (companyName) => {
  const data = await axios
    .post(`Apl/PostCompany?name=` + companyName)
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const PostAplWorkCard = async (WorkCard) => {
  const data = await axios.post(`/Apl/PostWorkCard`, WorkCard).catch((err) => {
    return errorMessage(err);
  });
  return data;
};

export const PostAplDocuments = async (file) => {
  const data = await axios
    .post(
      `/Apl/PostDocumentForPeriod?description=${file.description}&periodId=${
        file.periodId
      }&userIds=${file.userIds.join("&userIds=")}`,
      toFormData(file.document, "document"),
      { headers: { "Content-Type": "multipart/form-data;" } }
    )
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const PostEvaluationQuestions = async (questions) => {
  const data = await axios
    .post(`/Apl/CreateEvaluationQuestions`, JSON.stringify(questions, null, 1))
    .catch((err) => {
      return errorMessage(err);
    });
  return data.data.result;
};

export const UpdateEvaluationQuestion = async (question) => {
  const data = await axios
    .post(
      `/Apl/UpdateEvaluationQuestion?questionId=${question.id}`,
      JSON.stringify(question.question, null, 1)
    )
    .catch((err) => {
      return errorMessage(err);
    });
  return data.data.result;
};

export const DeleteEvaluationQuestion = async (questionId) => {
  const data = await axios
    .delete(`/Apl/DeleteEvaluationQuestion?questionId=${questionId}`)
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const DeleteWorkstep = async (stepId) => {
  const data = await axios
    .delete(`/Apl/DeleteWorkStep?stepId=${stepId}`)
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const DeleteWorkstepComponent = async (componentId) => {
  const data = await axios
    .delete(`/Apl/DeleteComponent?componentId=${componentId}`)
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const DeleteWorkCard = async (workCardId) => {
  const data = await axios
    .delete(`/Apl/DeleteWorkCard?workCardId=${workCardId}`)
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const EditWorkstepComponent = async (item) => {
  const data = await axios.patch(`/Apl/EditComponent`, item).catch((err) => {
    return errorMessage(err);
  });
  return data;
};

export const EditWorkStep = async (item) => {
  const data = await axios.patch(`/Apl/EditWorkStep`, item).catch((err) => {
    return errorMessage(err);
  });
  return data;
};

export const DeleteDocument = async (id) => {
  const data = await axios
    .delete(`/Apl/DeleteDocument?id=${id}`)
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const GetAplInformationPersons = async (id) => {
  const res = await axios
    .get(`/Apl/GetAplInformationPersons?periodId=${id}`)
    .catch((err) => {
      return errorMessage(err);
    });
  return res.data.result;
};

export const PostAplInformationPerson = async (person) => {
  const data = await axios
    .post(`/Apl/PostAplInformationPerson`, person)
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const PostInformationPersonsAndUsersForPeriod = async (
  informationPersons
) => {
  const data = await axios
    .post(`/Apl/SetInformationConnectionsForPeriod`, informationPersons)
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const UpdateInformationPerson = async (person) => {
  const data = await axios
    .post(`/Apl/UpdateInformationPerson`, person)
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const UpdateInformationPersonAddUsers = async (person) => {
  const data = await axios
    .post(`/Apl/UpdateInformationPersonAddUsers`, person)
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const UpdateInformationPersonRemoveUsers = async (person) => {
  const data = await axios
    .post(`/Apl/UpdateInformationPersonRemoveUsers`, person)
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const DeleteInformationPerson = async (id) => {
  const data = await axios
    .delete(`/Apl/DeleteInformationPerson?id=${id}`)
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const PostWorkCardComment = async (workCardComment) => {
  const res = await axios
    .post(
      `/Apl/PostWorkCardComment/?created=${workCardComment.created}&text=${workCardComment.text}&workRegistrationId=${workCardComment.workRegistrationId}`
    )
    .catch((err) => {
      return errorMessage(err);
    });
  return res.data.result;
};

export const RemoveAplPeriod = async (data) => {
  const res = await axios
    .delete(`/Apl/DeletePeriod/?periodId=${data.periodId}`)
    .catch((err) => {
      return errorMessage(err);
    });
  return res;
};

export const UpdateAplPeriodDates = async ({
  periodId,
  startDate,
  endDate,
}) => {
  const res = await axios
    .post(
      `/Apl/ChangePeriodDates/?periodId=${periodId}&newStartDate=${startDate}&newEndDate=${endDate}`
    )
    .catch((err) => {
      return errorMessage(err);
    });
  return res;
};

export const ChangeStudentSupervisor = async (ssv) => {
  const res = await axios
    .post(
      `/Apl/ChangeStudentsCompanyOrSupervisor/?studentId=${ssv.studentId}&supervisorId=${ssv.supervisor.id}&companyId=${ssv.companyId}&periodId=${ssv.periodId}`
    )
    .catch((err) => {
      return errorMessage(err);
    });
  return res;
};

export const AddStudentToPeriod = async (studentSupervisor) => {
  const res = await axios
    .post(
      `/Apl/AddStudentToPeriod?periodId=${studentSupervisor.periodId}&studentId=${studentSupervisor.studentId}&supervisorId=${studentSupervisor.supervisorId}&companyId=${studentSupervisor.companyId}`
    )
    .catch((err) => {
      return errorMessage(err);
    });
  return res;
};

export const ChangeStudentsAndSupervisorsInPeriod = async (item) => {
  const res = await axios
    .post(`/Apl/ChangeStudentsInPeriod`, {
      PeriodId: item.periodId,
      DeleteMissingStudents: item.deleteMissing,
      Students: item.students,
      StudentIdsToManage: item.studentIdsToManage,
    })
    .catch((err) => {
      return errorMessage(err);
    });
  return res;
};

export const AddWorkSteps = async (workStepResource) => {
  const res = await axios
    .post(`/Apl/PostWorkSteps`, workStepResource)
    .catch((err) => {
      return errorMessage(err);
    });
  return res.data.result;
};

export const AddWorkStepComponents = async (workStepComponentResource) => {
  const res = await axios
    .post(`/Apl/PostComponents`, workStepComponentResource)
    .catch((err) => {
      return errorMessage(err);
    });
  return res.data.result;
};

export const RemoveStudentFromPeriod = async (student) => {
  const res = await axios
    .post(
      `/Apl/RemoveStudentFromPeriod?periodId=${student.periodId}&studentId=${student.studentId}`
    )
    .catch((err) => {
      return errorMessage(err);
    });
  return res.data.result;
};

export const SetAttendanceValidity = async (updateObj) => {
  const res = await axios
    .post(
      `/Apl/SetAttendanceValidity?attendanceDay=${updateObj.attendanceDay}&wasPresent=${updateObj.wasPresent}&studentId=${updateObj.studentId}&periodId=${updateObj.periodId}`
    )
    .catch((err) => {
      return errorMessage(err);
    });
  return res.data.result;
};

export const PostAbsence = async (updateObj) => {
  const res = await axios
    .post(
      `/Apl/PostAbsenceByTeacher?studentId=${updateObj.studentId}&absenceDay=${updateObj.absenceDay}&timeFrom=${updateObj.timeFrom}&timeTo=${updateObj.timeTo}&comment=${updateObj.comment}&isWholeDay=${updateObj.isWholeDay}`
    )
    .catch((err) => {
      return errorMessage(err);
    });
  return res.data.result;
};

export const AddSchoolToSupervisor = async (supervisorSchool) => {
  const res = await axios
    .post(
      `/Apl/AddSchoolToSupervisor?supervisorId=${supervisorSchool.supervisorId}&schoolId=${supervisorSchool.schoolId}`
    )
    .catch((err) => {
      return errorMessage(err);
    });
  return res;
};

export const SignWorkCardRegistration = async (item) => {
  const res = await axios
    .post(
      `/Apl/SignWorkCardRegistration?workRegistrationId=${item.workRegistrationId}&signed=${item.signed}`
    )
    .catch((err) => {
      return errorMessage(err);
    });
  return res;
};

export const ExportAplPeriodToExcel = async (exportRequest) => {
  const response = await axios
    .post(`/Apl/ExportPeriodToExcel`, exportRequest, {
      responseType: "blob",
    })
    .catch((err) => {
      return errorMessage(err);
    });
  return response;
};

export const ChangeLockStatusForModuleForStudent = async (postObject) => {
  const res = await axios
    .post(
      `/Module/SetModuleLockStatus?moduleId=${postObject.moduleId}&studentId=${postObject.currentLevelId}&locked=${postObject.locked}`
    )
    .catch((err) => {
      return errorMessage(err);
    });
  return res;
};

export const ChangeLockStatusForModuleForClass = async (postObject) => {
  const res = await axios
    .post(
      `/Module/SetModuleLockStatusForClass?moduleId=${postObject.moduleId}&classId=${postObject.currentLevelId}&locked=${postObject.locked}`
    )
    .catch((err) => {
      return errorMessage(err);
    });
  return res;
};

export const ChangeLockStatusForEntireCourseForMultipleStudents = async (
  postObject
) => {
  const res = await axios
    .post(
      `/Course/SetCourseLockStatus?courseId=${postObject.courseId}&locked=${
        postObject.locked
      }&studentIds=${postObject.studentIds.join("&studentIds=")}`
    )
    .catch((err) => {
      return errorMessage(err);
    });
  return res;
};

export const PostInterestForMail = async (postObject) => {
  try {
    const res = await axios.post(`/ShopNew/SupportMail`, postObject);
    if (res.status < 200 || res.status > 299) {
      throw new Error(`Request failed with status ${res.status}`);
    }
    return res.data;
  } catch (err) {
    throw new Error(errorMessage(err));
  }
};

export const DeleteFinalExamVariant = async (id) => {
  const data = await axios
    .delete(`/Course/DeleteFinalExamVariant?id=${id}`)
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const ChangeFinalExamVariant = async (values) => {
  const data = await axios
    .put("/Course/EditFinalExamVariant", {
      id: values.id,
      name: values.name,
      studentIdsCanRun: values.studentIdsCanRun,
      studentIdsCanNotRun: values.studentIdsCanNotRun,
      studentIdsRemoved: values.studentIdsRemoved,
    })
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const MarkWorkRegistrationsAsViewed = async (periodId) => {
  const data = await axios
    .post(`/Apl/MarkWorkRegistrationsAsViewed?periodId=${periodId}`)
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};
